module.exports = "/static/assets/8f53648c1514a11895ff2c933f5753d6.png";